<template>
    <div>
        <div class="cursor-pointer" @click="showTerms = true">
            <slot />
        </div>

        <portal to="destination">
            <modal
                v-if="showTerms"
                :key="'sign-up-form'"
                @close="showTerms = false"
            >
                <div class="top-0 right-0 absolute">X</div>
                <h3 v-html="lang.playaresorts['terms-and-conditions']" />
                <div v-html="terms" />
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from './utilities/Modal';

export default {
    name: 'Terms',
    components: {
        Modal,
    },
    props: ['terms'],
    data() {
        return {
            showTerms: false,
        };
    },
};
</script>
